import { Injectable } from '@angular/core';
import { ShopPluginApi } from '@app/core/services/api/plugin-api.service';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';
import { Observable, ReplaySubject } from 'rxjs';
import { tap, first } from 'rxjs/operators';

// TODO maybe move to shared, in the shop plugin interface
export interface PromiseAISettings {
  id?: number;
  enabled: boolean;
  testMode: boolean;
  descriptionText?: string;
  fallbackText?: string;
  conditions?: any;
}

@Injectable({
  providedIn: 'root',
})
export class PromiseAIService {
  constructor(private pluginApi: ShopPluginApi) {
    this.initPromiseAISettings();
  }
  private promiseAISettings = new ReplaySubject<PromiseAISettings>(null);
  get promiseAISettings$() {
    return this.promiseAISettings.asObservable();
  }

  initPromiseAISettings() {
    this.pluginApi.get('/admin/promise-ai/settings').subscribe((response: PromiseAISettings) => {
      this.promiseAISettings.next(response);
    });
  }

  setPromiseAISettings(config: PromiseAISettings, shop: Shop): Observable<PromiseAISettings> {
    return this.pluginApi
      .post('/admin/promise-ai/settings', {
        ...config,
        shop: { id: shop.id, name: shop.name },
      })
      .pipe(
        tap((updatedConfig: PromiseAISettings) => {
          this.promiseAISettings.next(updatedConfig);
        }),
        first(),
      ) as Observable<PromiseAISettings>;
  }
}
